import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="mx-auto max-w-7xl px-4 py-32 sm:px-6 lg:px-12">
      <p className="font-mono-tech text-xs uppercase tracking-widest text-cyan-400">// 404</p>
      <h1 className="mt-4 text-4xl font-extrabold text-white sm:text-5xl">Page not found.</h1>
      <Link to="/" data-testid="not-found-home-link" className="mt-8 inline-block text-cyan-300 hover:text-white">← Back home</Link>
    </section>
  );
}
